import { CONSTANTS } from "client/utils/constants";

const choices = [CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED, CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED]

const validateChoice = (addressDetails: any) => {
    if(addressDetails?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY 
        || addressDetails?.assetDispositionChoice === CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY){
            return true
    }else {
        return false
    }
}

const ValidateName = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionName === undefined || addressDetails?.assetDispositionName === "" || addressDetails?.assetDispositionName === null) {
            error.assetDispositionNameError = "Please provide contact name";
        } else if (addressDetails?.assetDispositionName?.length > 50) { 
            error.assetDispositionNameError = "Please enter Name less than 50 characters";
        } else {
            error.assetDispositionNameError = "";
        }
    } else {
        error.assetDispositionNameError = "";
    }
    return error;
}

const ValidatePhone = (addressDetails: any, error: any) => {
    const phoneVal = addressDetails?.assetDispositionPhone?.match(/\d/g);
    if (validateChoice(addressDetails)) {
        if (phoneVal === "" || phoneVal === undefined || phoneVal === null || phoneVal?.length != 10 || phoneVal?.toString().trim()?.length == 0) {
            error.assetDispositionPhoneError = "Please enter valid phone";
        } else {
            error.assetDispositionPhoneError = "";
        }
    }
    else {
        error.assetDispositionPhoneError = "";
    }
    return error;
}

const ValidateSalePrice = (dispositionDetails: any, error: any) => {
    if (validateChoice(dispositionDetails)) {
        if (dispositionDetails?.assetDispositionSalePrice === "" || dispositionDetails?.assetDispositionSalePrice === undefined || dispositionDetails?.assetDispositionSalePrice === null) {
            error.assetDispositionSalePriceError = "Please enter sale price";
        } else {
            error.assetDispositionSalePriceError = "";
        }
    }
    else {
        error.assetDispositionSalePriceError = "";
    }
    return error;
}

const ValidateTotalPrice = (dispositionDetails: any, error: any) => {
    if (validateChoice(dispositionDetails)) {
        if (dispositionDetails?.assetDispositionTotalPrice === "" || dispositionDetails?.assetDispositionTotalPrice === undefined || dispositionDetails?.assetDispositionTotalPrice === null) {
            error.assetDispositionTotalPriceError = "Please enter total price";
        } else {
            error.assetDispositionTotalPriceError = "";
        }
    }
    else {
        error.assetDispositionTotalPriceError = "";
    }
    return error;
}

const ValidateAddress1 = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionAddress1 === undefined || addressDetails?.assetDispositionAddress1 === "" || addressDetails?.assetDispositionAddress1 === null) {
            error.assetDispositionAddress1Error = "Please enter address 1";
        } else if (addressDetails?.assetDispositionAddress1?.length > 50) {
            error.assetDispositionAddress1Error = "Please enter Address 1 less than 50 characters";
        } else {
            error.assetDispositionAddress1Error = "";
        }
    } else {
        error.assetDispositionAddress1Error = "";
    }
    return error;
}
const ValidateAddress2 = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionAddress2?.length > 50) {
            error.assetDispositionAddress2Error = "Please enter Address 2 less than 50 characters";
        } else {
            error.assetDispositionAddress2Error = "";
        }
    } else {
        error.assetDispositionAddress2Error = "";
    }
    return error;
}

const ValidateCity = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionCity === undefined || addressDetails?.assetDispositionCity === "" || addressDetails?.assetDispositionCity === null) {
            error.assetDispositionCityError = "Please enter city";
        } else if (addressDetails?.assetDispositionCity?.length > 100) {
            error.assetDispositionCityError = "Please enter City less than 100 characters.";
        } else {
            error.assetDispositionCityError = "";
        }
    }
    else {
        error.assetDispositionCityError = "";
    }
    return error;
}
const ValidateState = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionState === undefined || addressDetails?.assetDispositionState === "" || addressDetails?.assetDispositionState === null) {
            error.assetDispositionStateError = "Please enter state";
        } else if (addressDetails?.assetDispositionState?.length > 2) {
            error.assetDispositionStateError = "Please enter State less than 2 characters.";
        } else {
            error.assetDispositionStateError = "";
        }
    } else {
        error.assetDispositionStateError = "";
    }
    return error;
}
const ValidateZip = (addressDetails: any, error: any) => {
    if (validateChoice(addressDetails)) {
        if (addressDetails?.assetDispositionZip === undefined || addressDetails?.assetDispositionZip === 0 || addressDetails?.assetDispositionZip === null || addressDetails?.assetDispositionZip.toString() === "") {
            error.assetDispositionZipError = "Please enter zip";
        } else if (addressDetails?.assetDispositionZip.toString().length > 10) {
            error.assetDispositionZipError = "Please enter Zip less than 10 digits.";
        } else {
            error.assetDispositionZipError = "";
        }
    } else {
        error.assetDispositionZipError = "";
    }

    return error;
}

const ValidateDispositionSubChoice = (addressDetails: any, error:any) => {
    if (choices.includes(addressDetails?.assetDispositionChoice)) {
        if (addressDetails?.assetDispositionSubChoice === undefined || addressDetails?.assetDispositionSubChoice === "" || addressDetails?.assetDispositionSubChoice === null) {
            error.assetDispositionSubChoiceError = "Please select " + addressDetails?.assetDispositionChoice;
        } else {
            error.assetDispositionSubChoiceError = "";
        }
    } else {
        error.assetDispositionSubChoiceError = "";
    }

    return error;
}

export default {
    ValidateName,
    ValidatePhone,
    ValidateAddress1,
    ValidateCity,
    ValidateState,
    ValidateZip,
    ValidateAddress2,
    ValidateDispositionSubChoice,
    ValidateSalePrice,
    ValidateTotalPrice
}